import { gql, DocumentNode } from '@apollo/client';

export interface GetUserProfileQueryResult<UserType> {
  user: UserType;
}

export const getUserProfileQuery = (UserFragment: DocumentNode) => gql`
  query GetUserProfileQuery {
    user @rest(type: "User", path: "profile") {
      ...User
    }
  }
  ${UserFragment}
`;
